/*
 * UMW fix — Aug 4 2026
 * Judge.me "Cards Carousel" widget requests review photos at full original
 * resolution (1024px/768px) regardless of their ~230px display size, and
 * does not lazy-load them. No setting exists in Judge.me's admin or the
 * Shopify block schema to control this (confirmed via their own support).
 * This script rewrites the CDN width param down to a size that matches
 * actual display size and defers loading until the images are near
 * the viewport. Judge.me's CDN (imgix) honors the width= query param
 * directly, so no image quality is lost — just wasted resolution.
 */
(function () {
  var TARGET_WIDTH = 300; // ~1.3x the 230px display box, safe for retina screens
  var processed = new WeakSet();

  function optimizeImage(img) {
    if (!img || processed.has(img)) return;
    var src = img.currentSrc || img.src || '';
    if (src.indexOf('judgeme.com') === -1 && src.indexOf('judge.me') === -1) return;
    if (src.indexOf('width=') === -1) return;

    processed.add(img);

    var newSrc = src.replace(/width=\d+/, 'width=' + TARGET_WIDTH);
    if (newSrc !== src) {
      img.src = newSrc;
    }
    if (!img.hasAttribute('loading')) {
      img.setAttribute('loading', 'lazy');
    }
  }

  function scanForImages(root) {
    if (!root || !root.querySelectorAll) return;
    var imgs = root.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      optimizeImage(imgs[i]);
    }
  }

  // Catch images already in the DOM
  document.addEventListener('DOMContentLoaded', function () {
    scanForImages(document);
  });
  // In case this script runs after DOMContentLoaded already fired
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    scanForImages(document);
  }

  // Judge.me injects the carousel asynchronously — watch for it
  var observer = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var added = mutations[m].addedNodes;
      for (var n = 0; n < added.length; n++) {
        var node = added[n];
        if (node.nodeType !== 1) continue; // element nodes only
        if (node.tagName === 'IMG') {
          optimizeImage(node);
        } else {
          scanForImages(node);
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
